import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <div className="relative min-h-screen bg-slate-950 text-slate-100 antialiased selection:bg-orange-400/30 selection:text-orange-100">
      <div className="noise" aria-hidden="true" />
      <Navbar />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8" data-testid="privacy-page">
        <Link
          to="/"
          data-testid="privacy-back"
          className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-orange-400 transition-colors hover:text-orange-300"
        >
          <ArrowLeft className="h-4 w-4" />
          {t.privacy.back}
        </Link>
        <h1 className="mt-6 font-display text-4xl font-bold tracking-tighter text-slate-50 sm:text-5xl" data-testid="privacy-title">
          {t.privacy.title}
        </h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{t.privacy.updated}</p>
        <p className="mt-8 text-base leading-relaxed text-slate-300">{t.privacy.intro}</p>

        <div className="mt-12 space-y-10">
          {t.privacy.sections.map((s, i) => (
            <motion.section
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.03 }}
              data-testid={`privacy-section-${i + 1}`}
            >
              <h2 className="font-display text-xl font-bold tracking-tight text-slate-50">{s.h}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.p}</p>
            </motion.section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
